<template>
  <div class="icon-font-content">
    <div v-for="(item, index) in iconArray" :key="'icon' + index" class="icon-centent" :class="item.select ? 'selectType' : ''">
      <img :src="'/static/img/event-img/' + item.value" class="iconfont-img" @click="paddIconFontClassAction(item)"/>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iconfontArray: [
        'currency.png',
        'confirm-micro.png',
        'join-wheel.png',
        'leave-msg.png',
        'modify.png',
        'reply.png',
        'sweep-code.png',
        'sweep-bottle-code.png',
        'cancel-fllow.png',
        'forward-friend.png',
        'score-overdue.png',
        'goods.png',
        'activity-prize.png',
        'activity-share.png',
        'member-register.png',
        'member-sign.png',
        'member-score-exchange.png',
        'assistance-prize.png',
        'fllow-public.png',
        'fllow-public-wechat.png',
        'buy-goods.png',
        'visit-micro.png',
        'send-wechat-msg.png',
        'send-bag.png',
        'click-wechat-menu.png',
        'click-msg-link.png',
        'create-user.png'
      ],
      iconArray: []
    }
  },
  methods: {
    initData() {
      for (let item of this.iconfontArray) {
        this.iconArray.push({
          select: false,
          value: item
        })
      }
    },
    paddIconFontClassAction(item) {
      // val.select = true
      for (let it of this.iconArray) {
        // console.log('sssssss', item.value, it.value)
        if (item.value === it.value) {
          console.log('sssssss', it)
          it.select = true
        } else {
          it.select = false
        }
      }
      this.$emit('selectedIconFontClass', item.value)
    }
  },
  created() {
    this.initData()
  },
  computed: {
  },
  components: {
  },
  watch: {
  }
}
</script>
<style type="text/css" scoped>
.icon-font-content {
  /*height: 350px;
  width: 890px;*/
  height: 350px;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  border-radius: 5px;
  border: 1px solid #dedede;
  padding-top: 10px;
  margin-bottom: 20px;
}
.icon-font-content i {
  display: inline-block;
  height: 50px;
  width: 50px;
  float: left;
  overflow: hidden;
  font-size: 25px;
  /*color: #4882ff;*/
  margin: 0px;
}
.selectType {
  /*border: 1px red solid;*/
}
.icon-centent {
  display: inline-block;
  float: left;
  height: 40px;
  width: 50px;
}
.iconfont-img {
  height: 30px;
  width: 30px; 
}
</style>
